import { normalizeChatText } from 'Components/Chat/utils';
import { getGraphemes, isEmojiGrapheme } from './emojiUtils';

const MAX_LARGE_EMOJI_COUNT = 3;

/**
 * Returns true when a chat message should render with the large emoji size.
 *
 * Rules:
 * - Ignore leading reply markers (`@ref_{id} `)
 * - Ignore spaces and line breaks
 * - Message must contain only emojis
 * - Emoji count must be between 1 and 3 (inclusive)
 */
export const isLargeEmojiMessage = (text = ''): boolean => {
  const withoutReply = normalizeChatText(text);
  const withoutWhitespace = withoutReply.replace(/\s/g, '');

  if (!withoutWhitespace) {
    return false;
  }

  const graphemes = getGraphemes(withoutWhitespace);

  if (
    graphemes.length === 0 ||
    graphemes.length > MAX_LARGE_EMOJI_COUNT ||
    !graphemes.every(isEmojiGrapheme)
  ) {
    return false;
  }

  return true;
};
